import React from 'react'
import { Card, CardBody, CardTitle } from 'reactstrap';
import FadeIn from 'react-fade-in'
import Header from '../components/header'
import error from '../images/error.png'
import { isBrowser } from 'react-device-detect'
const {REACT_APP_NAME_LECCA} = process.env
export default class TelaErro extends React.Component {
  render(){
    if(isBrowser){
      return(
        <div>
            <FadeIn delay={150}>
                <Header/>

                <div className='card-style'>
                  <Card
                    body
                    className="text-center">
                      <img src={error} width='110px' height='105px' style={{margin: '20px auto'}} alt='failed'/>
                      <CardTitle tag="h5">
                        Link inválido
                      </CardTitle>
                      <CardBody>
                        <p><em>Infelizmente este link expirou. Por favor, entre em contato com a {REACT_APP_NAME_LECCA} para receber um novo link. </em></p>

                        <p><em>Time {REACT_APP_NAME_LECCA}</em></p>
                      </CardBody>
                  </Card>
                </div>
            </FadeIn>
      </div>
      );
    }else{
      return(
        <div>
          <FadeIn delay={150}>
              <Header/>
              
               <div className='card-style-mobile'>
                 <Card
                   body
                   className="text-center">
                     <img src={error} width='90px' height='80px' style={{margin: '20px auto'}} alt='failed'/>
                     <CardTitle tag="h5">
                        Link Inválido
                     </CardTitle>
                     <CardBody>

                       <p><em>Infelizmente este link expirou. Por favor, entre em contato com a {REACT_APP_NAME_LECCA} para receber um novo link. </em></p>
                        
                       <p><em>Time {REACT_APP_NAME_LECCA}</em></p>
                     </CardBody>
                 </Card>
               </div>
            </FadeIn>
      </div>
      );
    }
  } 
}